// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.counter-box {
  display: flex;
  gap: 1.5%;
  margin-bottom: 1.5%;
  min-height: 19.5vw;
}
.counter-box .container {
  width: 100%;
}
.counter-box .container .analytic-data {
  display: flex;
  gap: 1.5vw;
}
.counter-box .container .visitor-graph {
  margin-top: 2vw;
  padding: 2vw;
  background-color: #fff;
  position: relative;
}
.counter-box .container .visitor-graph:after {
  content: "No. of visitors";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0%, -50%) rotate(-90deg);
  font-size: 0.835vw;
  color: #616161;
}
.counter-box .container .visitor-graph .recharts-responsive-container {
  min-width: 100%;
  min-height: 200px;
}
.counter-box .container .visitor-graph .recharts-responsive-container tspan {
  font-size: 12px;
}
.counter-box .container .visitor-graph .recharts-responsive-container .recharts-tooltip-label {
  font-size: 12px;
}
.counter-box .container .visitor-graph .recharts-responsive-container .recharts-tooltip-item {
  color: #616161 !important;
}
.counter-box .container .visitor-graph .recharts-responsive-container .recharts-tooltip-item span {
  font-size: 12px;
}
.counter-box .conversion {
  width: 33.33%;
  background: rgba(255, 255, 255, 0.9);
  padding: 1.5vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-radius: 0.3vw;
  opacity: 0.5;
}
.counter-box .conversion .conversion-title {
  font-size: 0.91vw;
  font-weight: 500;
  line-height: 18px;
}
.counter-box .conversion p {
  font-weight: 500;
  font-size: 1.12vw;
  margin: 0.5vw 0 3vw;
}
.counter-box .conversion .conversion-data ul {
  flex-direction: column;
}
.counter-box .conversion .conversion-data ul li {
  width: 100%;
  margin-bottom: 1vw;
}
.counter-box .conversion .conversion-data ul li p {
  margin: 0;
  display: flex;
  justify-content: space-between;
  background: #F9F9F9;
  padding: 1vw;
  border-radius: 0.3vw;
  font-weight: 400;
  font-size: 0.85vw;
}
.counter-box .average-duration {
  width: 40%;
  background: rgba(255, 255, 255, 0.9);
  padding: 1.5vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-radius: 0.3vw;
  position: relative;
}
.counter-box .average-duration h2 {
  font-size: 0.91vw;
  font-weight: 500;
  margin-bottom: 1.5vw;
}
.counter-box .average-duration:after {
  content: "Average Duration of Stay (Minutes)";
  position: absolute;
  max-width: 10vw;
  left: 0;
  top: 50%;
  transform: translate(-3vw, -50%) rotate(-90deg);
  font-size: 0.835vw;
  color: #616161;
  text-align: center;
}
.counter-box .average-duration .recharts-responsive-container {
  min-width: 100%;
  min-height: 200px;
  max-height: 2vw;
}
.counter-box .average-duration .recharts-responsive-container tspan {
  font-size: 12px;
}
.counter-box .average-duration .recharts-responsive-container .recharts-tooltip-label {
  font-size: 12px;
}
.counter-box .average-duration .recharts-responsive-container .recharts-tooltip-item {
  color: #616161 !important;
}
.counter-box .average-duration .recharts-responsive-container .recharts-tooltip-item span {
  font-size: 12px;
}
.counter-box .country-map {
  width: 60%;
  background: rgba(255, 255, 255, 0.9);
  padding: 1.5vw;
  box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);
  border-radius: 0.3vw;
  position: relative;
}
.counter-box .country-map h2 {
  font-size: 0.91vw;
  font-weight: 500;
  margin-bottom: 1.5vw;
}
.counter-box .country-map li.google-visualization-tooltip-item:first-child {
  display: none;
}
.counter-box .country-map .country-list .country-box {
  max-height: 175px;
  overflow-y: scroll;
}
.counter-box .country-map .country-list h3 {
  font-size: 0.85vw;
  font-weight: 400;
  color: #616161;
  margin-bottom: 0.5vw;
}
.counter-box .country-map .country-list .country-data {
  display: flex;
  gap: 1.5%;
}
.counter-box .country-map .country-list .country-data > div:first-child {
  width: 30px;
}
.counter-box .country-map .country-list .country-data > div:last-child {
  width: calc(100% - 30px);
}
.counter-box .country-map .country-list .country-data p {
  font-size: 0.91vw;
  font-weight: 500;
  color: #616161;
}
.counter-box .country-map .country-list .country-data p span {
  width: 100%;
}
.counter-box .country-map .country-list .country-data .country-flag {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  object-fit: cover;
}
.counter-box .country-map .country-list .percentage-data {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5%;
}
.counter-box .country-map .country-list .percentage-data .percentage-bar {
  width: 100%;
  height: 0.75vw;
  overflow: hidden;
  background: #E6E6E6;
  border-radius: 1vw;
}`, "",{"version":3,"sources":["webpack://./src/style/components/analytics/VisitorAnalytic.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;AACF;AAAE;EACE,WAAA;AAEJ;AADI;EACE,aAAA;EACA,UAAA;AAGN;AADI;EACE,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AAGN;AAFM;EACE,0BAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,6CAAA;EACA,kBAAA;EACA,cAAA;AAIR;AAFM;EACE,eAAA;EACA,iBAAA;AAIR;AAHQ;EACE,eAAA;AAKV;AAHQ;EACE,eAAA;AAKV;AAHQ;EACE,yBAAA;AAKV;AAJU;EACE,eAAA;AAMZ;AAAE;EACE,aAAA;EACA,oCAAA;EACA,cAAA;EACA,+DAAA;EACA,oBAAA;EAGA,YAAA;AAAJ;AACI;EACE,iBAAA;EACA,gBAAA;EACA,iBAAA;AACN;AACI;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;AACN;AAEQ;EACI,sBAAA;AAAZ;AACY;EACI,WAAA;EACA,kBAAA;AAChB;AAAgB;EACI,SAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,iBAAA;AAEpB;AAIE;EACE,UAAA;EACA,oCAAA;EACA,cAAA;EACA,+DAAA;EACA,oBAAA;EACA,kBAAA;AAFJ;AAGI;EACI,iBAAA;EACA,gBAAA;EACA,oBAAA;AADR;AAGI;EACI,6CAAA;EACA,kBAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,+CAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AADR;AAGM;EACE,eAAA;EACA,iBAAA;EACA,eAAA;AADR;AAEQ;EACE,eAAA;AAAV;AAEQ;EACE,eAAA;AAAV;AAEQ;EACE,yBAAA;AAAV;AACU;EACE,eAAA;AACZ;AAIA;EACI,UAAA;EACA,oCAAA;EACA,cAAA;EACA,+DAAA;EACA,oBAAA;EACA,kBAAA;AAFJ;AAGI;EACI,iBAAA;EACA,gBAAA;EACA,oBAAA;AADR;AAGI;EACI,aAAA;AADR;AAIQ;EACE,iBAAA;EACC,kBAAA;AAFX;AAIQ;EACI,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;AAFZ;AAIQ;EACI,aAAA;EACA,SAAA;AAFZ;AAGY;EACI,WAAA;AADhB;AAGa;EACG,wBAAA;AADhB;AAGa;EACG,iBAAA;EACA,gBAAA;EACA,cAAA;AADhB;AAEgB;EACI,WAAA;AAApB;AAKY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAHhB;AAMQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAJZ;AAKY;EACI,WAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAHhB","sourcesContent":[".counter-box {\n  display: flex;\n  gap: 1.5%;\n  margin-bottom: 1.5%;\n  min-height: 19.5vw;\n  .container {\n    width: 100%;\n    .analytic-data {\n      display: flex;\n      gap: 1.5vw;\n    }\n    .visitor-graph {\n      margin-top: 2vw;\n      padding: 2vw;\n      background-color: #fff;\n      position: relative;\n      &:after {\n        content: \"No. of visitors\";\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translate(0%, -50%) rotate(-90deg);\n        font-size: 0.835vw;\n        color: #616161;\n      }\n      .recharts-responsive-container {\n        min-width: 100%;\n        min-height: 200px;\n        tspan {\n          font-size: 12px;\n        }\n        .recharts-tooltip-label {\n          font-size: 12px;\n        }\n        .recharts-tooltip-item {\n          color: #616161 !important;\n          span {\n            font-size: 12px;\n          }\n        }\n      }\n    }\n  }\n  .conversion {\n    width: 33.33%;\n    background: rgba(255, 255, 255, 0.9);\n    padding: 1.5vw;\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    border-radius: 0.3vw;\n    //hiding the coversion rate\n    // display: none;\n    opacity: .5;\n    .conversion-title {\n      font-size: 0.91vw;\n      font-weight: 500;\n      line-height: 18px;\n    }\n    p {\n      font-weight: 500;\n      font-size: 1.12vw;\n      margin: 0.5vw 0 3vw;\n    }\n    .conversion-data{\n        ul{\n            flex-direction: column;\n            li{\n                width: 100%;\n                margin-bottom: 1vw;\n                p{\n                    margin: 0;\n                    display: flex;\n                    justify-content: space-between;\n                    background: #F9F9F9;\n                    padding: 1vw;\n                    border-radius: .3vw;\n                    font-weight: 400;\n                    font-size: .85vw;\n                }\n            }\n        }\n    }\n  }\n  .average-duration {\n    width: 40%;\n    background: rgba(255, 255, 255, 0.9);\n    padding: 1.5vw;\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    border-radius: 0.3vw;\n    position: relative;\n    h2{\n        font-size: .91vw;\n        font-weight: 500;\n        margin-bottom: 1.5vw;\n    }\n    &:after {\n        content: \"Average Duration of Stay (Minutes)\";\n        position: absolute;\n        max-width: 10vw;\n        left: 0;\n        top: 50%;\n        transform: translate(-3vw, -50%) rotate(-90deg);\n        font-size: 0.835vw;\n        color: #616161;\n        text-align: center;\n      }\n      .recharts-responsive-container {\n        min-width: 100%;\n        min-height: 200px;\n        max-height: 2vw;\n        tspan {\n          font-size: 12px;\n        }\n        .recharts-tooltip-label {\n          font-size: 12px;\n        }\n        .recharts-tooltip-item {\n          color: #616161 !important;\n          span {\n            font-size: 12px;\n          }\n        }\n      }\n}\n.country-map{\n    width: 60%;\n    background: rgba(255, 255, 255, 0.9);\n    padding: 1.5vw;\n    box-shadow: 0px 4px 7.4px 0px rgba(190, 190, 190, 0.2509803922);\n    border-radius: 0.3vw;\n    position: relative;\n    h2{\n        font-size: .91vw;\n        font-weight: 500;\n        margin-bottom: 1.5vw;\n    }\n    li.google-visualization-tooltip-item:first-child {\n        display: none;\n    }\n    .country-list{        \n        .country-box{\n          max-height: 175px;\n           overflow-y: scroll;\n        }\n        h3{\n            font-size: .85vw;\n            font-weight: 400;\n            color: #616161;\n            margin-bottom: .5vw;\n        }\n        .country-data {\n            display: flex;\n            gap:1.5%;\n            & >div:first-child{\n                width:30px;\n             }\n             & >div:last-child{\n                width:calc(100% - 30px);\n             }\n             p{\n                font-size: 0.91vw;\n                font-weight: 500;\n                color: #616161;\n                span{\n                    width: 100%;\n                }\n             }\n\n\n            .country-flag {\n                width: 25px;\n                height: 25px;\n                border-radius: 50%;\n                object-fit: cover;\n            }\n        }\n        .percentage-data {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            gap: 1.5%;\n            .percentage-bar {\n                width: 100%;\n                height: .75vw;\n                overflow: hidden;\n                background: #E6E6E6;\n                border-radius: 1vw;\n            }\n        }\n    }\n}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
